import React, { createContext, useEffect, useMemo, useState } from 'react'
import { darkTheme, lightTheme } from '../themes.js'

export const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const storedValue = localStorage.getItem('isDarkMode')
    return storedValue !== null ? storedValue === '1' : true
  })

  useEffect(() => {
    localStorage.setItem('isDarkMode', isDarkMode ? '1' : '0')
  }, [isDarkMode])

  useEffect(() => {
    document.body.classList.toggle('theme-dark', isDarkMode)
    document.body.classList.toggle('theme-light', !isDarkMode)
    document.documentElement.setAttribute(
      'data-bs-theme',
      isDarkMode ? 'dark' : 'light'
    )
  }, [isDarkMode])

  const theme = useMemo(() => {
    return isDarkMode ? darkTheme : lightTheme
  }, [isDarkMode])

  const value = useMemo(
    () => ({
      theme,
      isDarkMode,
      setIsDarkMode
    }),
    [theme, isDarkMode]
  )

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
